import styled from '@emotion/styled'

import theme from 'styles/theme'

export const StyledHeading = styled.h2`
  font-size: ${theme.token.var('fontSizes.lg')};
  text-align: left;
  line-height: 1;

  @media (min-width: ${theme.token('breakpoints.md')}) {
    font-size: ${theme.token.var('fontSizes.2xl')};
  }
`

export const StyledHeadingCentered = styled.h2`
  font-size: ${theme.token.var('fontSizes.lg')};
  text-align: center;
  line-height: 1;

  @media (min-width: ${theme.token('breakpoints.md')}) {
    font-size: ${theme.token.var('fontSizes.2xl')};
  }
`
